import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

const style = {
  h4: (theme: Theme): SystemStyleObject<Theme> => ({
    marginLeft: 1,
    color: theme.palette.secondary.main,
  }),
  iconWrapper: (): SystemStyleObject<Theme> => ({
    display: "flex",
    alignItems: "center",
    position: "relative",
    marginTop: 2,
    marginBottom: 2,
  }),
  icon: (theme: Theme): SystemStyleObject<Theme> => ({
    position: "absolute",
    left: 6,
    zIndex: 2,
    color: theme.palette.text.secondary,
  }),
};

export default style;
